import { render, staticRenderFns } from "./AppointPractitioner.vue?vue&type=template&id=039f07ba&scoped=true&"
import script from "./AppointPractitioner.vue?vue&type=script&lang=js&"
export * from "./AppointPractitioner.vue?vue&type=script&lang=js&"
import style0 from "./AppointPractitioner.vue?vue&type=style&index=0&id=039f07ba&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "039f07ba",
  null
  
)

export default component.exports